import MobileBusiness from './MobileBusiness'

export default MobileBusiness;